import React from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import "./WidgetWrapper.scss";

const WidgetWrapper = ({
  title,
  subtitle,
  loading,
  error,
  onRetry,
  onRemove,
  onConfigure,
  customizeMode,
  children,
  action,
}) => {
  return (
    <div className={`dash-widget${customizeMode ? " dash-widget--customize" : ""}`}>
      <div className="dash-widget__header">
        <div style={{ minWidth: 0 }}>
          <span className="dash-widget__title">{title}</span>
          {subtitle && <div className="dash-widget__subtitle">{subtitle}</div>}
        </div>
        <div className="dash-widget__header-right">
          {action && !loading && !error && (
            <span className="dash-widget__action">{action}</span>
          )}
          {customizeMode && onConfigure && (
            <Tooltip title="Configure widget">
              <IconButton size="small" className="dash-widget__configure" onClick={onConfigure}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="3"/>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                </svg>
              </IconButton>
            </Tooltip>
          )}
          {customizeMode && onRemove && (
            <Tooltip title="Remove widget">
              <IconButton size="small" className="dash-widget__remove" onClick={onRemove}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
                  <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/>
                </svg>
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>

      <div className="dash-widget__body">
        {loading ? (
          <div className="dash-widget__skeleton">
            <Skeleton variant="rect" height={28} width="55%" style={{ borderRadius: 4, marginBottom: 8 }} />
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="rect" height={48} style={{ borderRadius: 4, marginTop: 12 }} />
          </div>
        ) : error ? (
          <div className="dash-widget__error">
            <span>Failed to load</span>
            {onRetry && (
              <button className="dash-widget__retry" onClick={onRetry}>
                Retry
              </button>
            )}
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default WidgetWrapper;
